import * as ApiNames from './ApiNames';
import * as Features from './_MerchandiseFeatures';
export const ApiNameToFeaturesMap = {
  [ApiNames.MARKETING_HUB_STARTER]: Features._marketingStarterFeatureIds,
  [ApiNames.MARKETING_HUB_PROFESSIONAL]: Features._marketingProfessionalFeatureIds,
  [ApiNames.MARKETING_HUB_ENTERPRISE]: Features._marketingEnterpriseFeatureIds,
  [ApiNames.SALES_HUB_STARTER]: Features._salesStarterFeatureIds,
  [ApiNames.SALES_HUB_PROFESSIONAL]: Features._salesProfessionalFeatureIds,
  [ApiNames.SALES_HUB_ENTERPRISE]: Features._salesEnterpriseFeatureIds,
  [ApiNames.SERVICE_HUB_STARTER]: Features._serviceStarterFeatureIds,
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: Features._serviceProfessionalFeatureIds,
  [ApiNames.SERVICE_HUB_ENTERPRISE]: Features._serviceEnterpriseFeatureIds,
  [ApiNames.CMS_HUB_FREE]: {},
  [ApiNames.CMS_HUB_STARTER]: Features._cmsStarterFeatureIds,
  [ApiNames.CMS_HUB_PROFESSIONAL]: Features._cmsProfessionalFeatureIds,
  [ApiNames.CMS_HUB_ENTERPRISE]: Features._cmsEnterpriseFeatureIds,
  [ApiNames.OPERATIONS_HUB_STARTER]: Features._operationsStarterFeatureIds,
  [ApiNames.OPERATIONS_HUB_PROFESSIONAL]: Features._operationsProfessionalFeatureIds,
  [ApiNames.OPERATIONS_HUB_ENTERPRISE]: Features._operationsEnterpriseFeatureIds
};